<template lang="pug">
.athletes
  h3(v-if="title") {{ __(title, 'auto') }}
  .athlete-grid
    .athlete-class(v-for="n in Math.min(athletes.length || placeholderCount, 3)" :key="n")
      .athlete
        .photo.photo-skeleton
        .description
          .name.text-bar
          .country.text-bar
</template>

<script setup lang="ts">
defineProps({
  title: {
    type     : String,
    required : false,
  },
  athletes: {
    type    : Array,
    default : () => ([]),
  },
  placeholderCount: {
    type    : Number,
    default : 10,
  },
})

</script>

<style scoped lang="scss">
@keyframes skeleton-loading {
  0% { background-color: $color-gray-x-light; }
  100% { background-color: $color-gray-light; }
}

.photo-skeleton {
  width: 90px;
  border-radius: $radius-default;
  animation: skeleton-loading 1s linear infinite alternate;

  @media (max-width: 420px) {
    width: 120px;
  }
}

.text-bar {
  border-radius: $radius-default;
  animation: skeleton-loading 1s linear infinite alternate;
}

.name.text-bar {
  height: $size-s;
  width: 80px;
  margin-bottom: $space-xxs;
}

.country.text-bar {
  height: $size-xs;
  width: 60px;
}

// Mirrors Athletes.vue's .athlete-grid/.athlete-class layout
.athlete-grid {
  display: grid;
  grid-template-columns: repeat(5, 20%);
  grid-row-gap: $space-m;
  grid-column-gap: $space-m;

  @media (max-width: 1475px) {
    grid-template-columns: repeat(5, 19%);
  }

  @include tablet-and-small-desktop() {
    grid-template-columns: repeat(3, 33%);
  }

  @include mobile() {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 420px) {
    grid-template-columns: repeat(1, 100%);
    margin-left: $space-m;

    .athlete-class .athlete .photo {
      max-width: 120px;
      height: 120px;
      margin-right: $size-m;
    }
  }
}

.athletes h3 {
  padding-left: $size-s;
  margin-bottom: 4px;
}

.athlete-class {
  .athlete {
    display: flex;

    .photo {
      max-width: 90px;
      height: 90px;
      margin-right: $space-xs;
    }
  }
}
</style>
